import { ElementLogic } from '../../../core/canvas-logic/base/element-logic';

export class CommonThumbnailLogic extends ElementLogic {
    public removeLogic(): void {}
}
